import { render, staticRenderFns } from "./MenuMainpage.vue?vue&type=template&id=bdeb3d3c&lang=html"
import script from "./MenuMainpage.vue?vue&type=script&lang=js"
export * from "./MenuMainpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports